import React, { useState, useRef, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { FaChevronDown, FaTimes, FaBars } from 'react-icons/fa'
import '../styles/global.css' // Or wherever your CSS file is located

const Navigation = () => {
  // const { isAuthenticated } = useAuth()
  // Temporary placeholder removed to fix ESLint warning
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [mobileCnaeDropdownOpen, setMobileCnaeDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)
  const mobileMenuRef = useRef(null)
  const location = useLocation()

  // Close dropdown and mobile menu when location changes (navigation)
  useEffect(() => {
    setDropdownOpen(false)
    setMobileMenuOpen(false)
    setMobileCnaeDropdownOpen(false)
  }, [location])

  const toggleDropdown = (e) => {
    e.preventDefault()
    e.stopPropagation() // Prevent event bubbling
    setDropdownOpen((prev) => !prev) // Use functional update to ensure we're toggling the current state
  }

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev)
    // Close mobile CNAE dropdown when closing the menu
    if (mobileMenuOpen) {
      setMobileCnaeDropdownOpen(false)
    }
  }

  const toggleMobileCnaeDropdown = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setMobileCnaeDropdownOpen((prev) => !prev)
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  // Prevent body scrolling when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [mobileMenuOpen])

  return (
    <nav className='bg-background border-b border-border py-4'>
      <div className='container mx-auto px-4'>
        <div className='flex items-center justify-between'>
          <div className='text-primary font-bold text-xl'>
            <Link to='/'>Conversor IAE CNAE</Link>
          </div>

          {/* Desktop Navigation */}
          <div className='hidden md:flex items-center justify-center flex-1'>
            <ul className='flex space-x-6'>
              <li>
                <Link
                  to='/'
                  className='text-text-primary font-semibold hover:text-primary transition-colors'
                >
                  Conversor
                </Link>
              </li>
              <li className='relative' ref={dropdownRef}>
                <span
                  onClick={toggleDropdown}
                  className={`text-text-primary font-semibold flex items-center cursor-pointer ${
                    dropdownOpen ? 'text-primary' : ''
                  }`}
                >
                  Códigos CNAE <FaChevronDown className='ml-1 text-xs' />
                </span>
                {dropdownOpen && (
                  <ul className='absolute right-0 mt-2 w-48 bg-background border border-border rounded-md shadow-lg z-10'>
                    <li>
                      <Link
                        to='/codigos-cnae-2025/'
                        onClick={() => setDropdownOpen(false)}
                        className='block px-4 py-2 text-text-primary hover:bg-opacity-5 hover:bg-white hover:text-primary hover:pl-5 transition-all'
                      >
                        CNAE 2025
                      </Link>
                    </li>
                    <li>
                      <Link
                        to='/codigos-cnae-2009/'
                        onClick={() => setDropdownOpen(false)}
                        className='block px-4 py-2 text-text-primary hover:bg-opacity-5 hover:bg-white hover:text-primary hover:pl-5 transition-all'
                      >
                        CNAE 2009
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li>
                <Link
                  to='/epigrafes-iae/'
                  className='text-text-primary font-semibold hover:text-primary transition-colors'
                >
                  Epígrafes IAE
                </Link>
              </li>
              <li>
                <Link
                  to='/correspondencia-entre-codigos-cnae-2025-cnae-2009/'
                  className='text-text-primary font-semibold hover:text-primary transition-colors'
                >
                  Correspondencias CNAE
                </Link>
              </li>
              <li>
                <Link
                  to='/newsletter/'
                  className='text-text-primary font-semibold hover:text-primary transition-colors'
                >
                  Newsletter
                </Link>
              </li>
            </ul>
          </div>

          {/* Desktop Auth Section */}
          <div className='hidden md:block'>
            <a
              href='https://www.reddit.com/r/ConversorIAE_CNAE/'
              target='_blank'
              rel='noopener noreferrer'
              className='bg-primary text-background px-4 py-2 rounded font-medium hover:bg-secondary hover:opacity-90 hover:text-text-primary transition-colors'
            >
              Únete a la comunidad
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className='md:hidden text-text-primary text-xl p-1'
            onClick={toggleMobileMenu}
          >
            <FaBars />
          </button>

          {/* Mobile Sidebar Menu */}
          <div
            className={`fixed top-0 right-0 w-4/5 max-w-xs h-full bg-background shadow-lg z-50 transform transition-transform duration-300 ${
              mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
            } overflow-y-auto flex flex-col p-6`}
            ref={mobileMenuRef}
          >
            <button
              className='absolute top-4 right-4 text-text-primary text-lg'
              onClick={toggleMobileMenu}
            >
              <FaTimes />
            </button>
            <div className='mt-10 flex flex-col h-full'>
              <ul className='flex flex-col space-y-4'>
                <li className='py-2 border-b border-border'>
                  <Link
                    to='/'
                    onClick={toggleMobileMenu}
                    className='text-text-primary font-semibold block py-2'
                  >
                    Conversor
                  </Link>
                </li>

                <li className='py-2 border-b border-border'>
                  <span
                    onClick={toggleMobileCnaeDropdown}
                    className={`flex justify-between items-center cursor-pointer font-semibold text-text-primary py-2 ${
                      mobileCnaeDropdownOpen ? 'text-primary' : ''
                    }`}
                  >
                    Códigos CNAE{' '}
                    <FaChevronDown
                      className={`transition-transform ${
                        mobileCnaeDropdownOpen ? 'rotate-180' : ''
                      }`}
                    />
                  </span>
                  {mobileCnaeDropdownOpen && (
                    <ul className='pl-4 mt-2'>
                      <li>
                        <Link
                          to='/codigos-cnae-2025/'
                          onClick={toggleMobileMenu}
                          className='text-text-primary block py-1'
                        >
                          CNAE 2025
                        </Link>
                      </li>
                      <li>
                        <Link
                          to='/codigos-cnae-2009/'
                          onClick={toggleMobileMenu}
                          className='text-text-primary block py-1'
                        >
                          CNAE 2009
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li className='py-2 border-b border-border'>
                  <Link
                    to='/epigrafes-iae/'
                    onClick={toggleMobileMenu}
                    className='text-text-primary font-semibold block py-2'
                  >
                    Epígrafes IAE
                  </Link>
                </li>
                <li className='py-2 border-b border-border'>
                  <Link
                    to='/correspondencia-entre-codigos-cnae-2025-cnae-2009/'
                    onClick={toggleMobileMenu}
                    className='text-text-primary font-semibold block py-2'
                  >
                    Correspondencias CNAE
                  </Link>
                </li>
                <li className='py-2 border-b border-border'>
                  <Link
                    to='/newsletter/'
                    onClick={toggleMobileMenu}
                    className='text-text-primary font-semibold block py-2'
                  >
                    Newsletter
                  </Link>
                </li>
              </ul>
              <div className='mt-auto py-6 flex justify-center'>
                <a
                  href='https://www.reddit.com/r/ConversorIAE_CNAE/'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='bg-primary text-background w-full text-center px-4 py-2 rounded font-medium'
                >
                  Únete a la comunidad
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navigation
